import JobPostingResponses from "../components/Recruiting/JobPostingResponses.vue";
import {PERM} from "../utilites/permissions";

const jobPostingResponses = [
  {
    path: '/responses/:id(\\d+)?',
    name: 'JobPostingResponses',
    component: JobPostingResponses,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.RECRUIT_CANDIDATE,
      ]
    }
  },
];

export default jobPostingResponses;



// WEBPACK FOOTER //
// ./src/router/jobPostingResponses.js